import React, { useState } from 'react';

function StepOne({ onNext }) {
    const [agreed, setAgreed] = useState(true); // default to true so the button is active

    return (
        <div className="step-form">
            <h2>Welcome 👋<br /> to the Staff Onboarding Portal</h2>
            <p>Please provide the information so we can create your profile and arrange the necessary access and enrolment.</p>

            {/* 
            <div className="form-check form_input_hide">
                <input
                    type="checkbox"
                    checked={agreed}
                    id="accept_all"
                    onChange={() => setAgreed(!agreed)}
                />
                <label htmlFor="accept_all">
                    <span>I agree to the <a href="#">Terms & Conditions</a> and <a href="#">Privacy Policy</a>.</span>
                </label>
            </div> 
            */}

            <button
                className="btn btn-dark px-4 mt-4"
                onClick={() => onNext({ agreed })}
                disabled={!agreed}
            >
                Get Started
            </button>
        </div>
    );
}

export default StepOne;
